import { DEFAULT_POD_CACHE_KEY_PREFIX, DETACHED_POD_ID, POD_CONNECTED_EVENT } from './constant/constants';
/**
 * Util method to make and return a unique cache key
 * @returns a string
 */
export function getCacheKey(userCacheKey) {
    return `${DEFAULT_POD_CACHE_KEY_PREFIX}_${userCacheKey}`;
}
/**
 * Util method to update cache with new podId
 */
export function updateCache(mfsClient, mfsLocalStore, cacheKey, dataStore) {
    //PodId is not retrieved from ODSP yet, wait for fluidConnected event and then put the value in cache. Otherwise, cached podID will be 'detachedPodId`. Once you update the cache, then unsubscribe from fluidConnected event
    if (dataStore.getId() == DETACHED_POD_ID) {
        const onClientSubcription = async () => {
            mfsLocalStore.set(cacheKey, dataStore.getId());
            mfsClient.off(POD_CONNECTED_EVENT, onClientSubcription);
        };
        mfsClient.on(POD_CONNECTED_EVENT, onClientSubcription);
    }
    else {
        mfsLocalStore.set(cacheKey, dataStore.getId());
    }
}
//# sourceMappingURL=cacheUtility.js.map